import type { FaireProductEntity } from "../../entity_types/product";

export const p_6czzft5fyf: FaireProductEntity = {
  token: "p_6czzft5fyf",
  type: "product",
  name: 'Wildlife Bud Vase-2"H',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/7c8f602489a94e9faa926bdafb44f92d258deedf82dd7c366cff68af5e155825.jpeg",
  priceDollars: 5.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/4c64c02474b088bc204b4515a720db6c584d2be52e591222354ebbf0b504c722.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
